import { render, staticRenderFns } from "./GradeDetail.vue?vue&type=template&id=729275db&"
import script from "./GradeDetail.vue?vue&type=script&lang=js&"
export * from "./GradeDetail.vue?vue&type=script&lang=js&"
import style0 from "./GradeDetail.vue?vue&type=style&index=0&id=729275db&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports